import { IconWrapper, IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import { Box, Checkbox, SxProps, Typography } from '@mui/material';

interface IBestAttemptCheck {
  checkedState: boolean;
  onChangeCheckbox: () => void;
  labelText: string;
  disabled?: boolean;
  rootStyles?: SxProps;
}
export const BestAttemptCheck = (props: IBestAttemptCheck) => {
  const { checkedState, onChangeCheckbox, labelText, disabled, rootStyles } =
    props;

  const styles: IStyles = {
    bestAttemptCheck: {
      width: '100%',
      display: 'flex',
      gap: { xs: pxToRem(10), md: pxTovW(15) },
      backgroundColor: '#FFF6D2',
      border: '2px solid #F8C807',
      borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
      paddingY: { xs: pxToRem(7), md: pxTovW(15), lg: pxTovW(15) },
      paddingX: { xs: pxToRem(10), md: pxTovW(20), lg: pxTovW(20) },
      boxSizing: 'border-box',
      alignItems: 'center',
      ...rootStyles,
    },
    checkbox: {
      boxSizing: 'border-box',
      maxWidth: 'max-content',
    },
    checkboxIcon: {
      width: { xs: pxToRem(29), md: pxTovW(55), lg: pxTovW(51) },
      height: { xs: pxToRem(29), md: pxTovW(55), lg: pxTovW(51) },
      backgroundColor: disabled ? '#DCDCDC' : 'white',
      border: '1px solid #F8C807',
      borderRadius: { xs: pxToRem(5), md: pxTovW(5) },
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
  };

  return (
    <Box sx={styles.bestAttemptCheck}>
      <Checkbox
        checked={checkedState}
        onChange={onChangeCheckbox}
        color="info"
        disabled={disabled}
        sx={styles.checkbox}
        icon={<Box sx={styles.checkboxIcon}></Box>}
        checkedIcon={
          <Box sx={styles.checkboxIcon}>
            <IconWrapper
              name="check-black"
              type="png"
              parentFolder="icons"
              size="md"
            />
          </Box>
        }
      />
      <Typography variant="h3" fontWeight="bold">
        {labelText}
      </Typography>
    </Box>
  );
};
